export const projectStatusConstants = {
  RETRIEVE_PROJECT_STATUS: 'RETRIEVE_PROJECT_STATUS',
}
